"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLegalConsentOptions = void 0;

var getLegalConsentOptions = function getLegalConsentOptions(state) {
  return state.dynosEditor.editableDyno.legalConsentOptions;
};

exports.getLegalConsentOptions = getLegalConsentOptions;